var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10Z",
    fill: "#F24F63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0889 4.95117C10.5031 4.95117 10.8389 5.28696 10.8389 5.70117V8.93221C10.8389 9.34642 10.5031 9.68221 10.0889 9.68221C9.67465 9.68221 9.33887 9.34642 9.33887 8.93221V5.70117C9.33887 5.28696 9.67465 4.95117 10.0889 4.95117Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31882 11.394C9.52295 11.1899 9.79982 11.0752 10.0885 11.0752C10.3772 11.0752 10.6541 11.1899 10.8582 11.394C11.0623 11.5981 11.177 11.875 11.177 12.1637C11.177 12.4524 11.0623 12.7293 10.8582 12.9334C10.6541 13.1375 10.3772 13.2522 10.0885 13.2522C9.79982 13.2522 9.52295 13.1375 9.31882 12.9334C9.11468 12.7293 9 12.4524 9 12.1637C9 11.875 9.11468 11.5981 9.31882 11.394ZM10.0885 12.1752C10.0916 12.1752 10.0945 12.174 10.0966 12.1718C10.0988 12.1697 10.1 12.1667 10.1 12.1637C10.1 12.1607 10.0988 12.1577 10.0966 12.1556C10.0945 12.1534 10.0916 12.1522 10.0885 12.1522C10.0855 12.1522 10.0825 12.1534 10.0804 12.1556C10.0782 12.1577 10.077 12.1607 10.077 12.1637C10.077 12.1667 10.0782 12.1697 10.0804 12.1718C10.0825 12.174 10.0855 12.1752 10.0885 12.1752Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.386570ba.svg";
export { ForwardRef as ReactComponent };